import { simpleSet } from '@r/reducers/utils';

const setCalculationModeNewProjectTab = simpleSet as
  redux.reducers.calculationMode.tabs.newProject;

export const newProject = setCalculationModeNewProjectTab(
  'SET_CALCULATION_MODE_NEW_PROJECT_TAB',
  'projectInformation'
);
